<template>
  <div>
    <wh-mobile-list
      ref="farmWorkRecordList"
      class="farm-work-record-list"
      :extra-params="extraParams"
      data-src="/api/getFarmWorkRecords"
    >
      <template v-slot="{list}">
        <farm-work-record-item
          v-for="(item,key) in list"
          :key="key"
          class="farm-work-record-item"
          :item="item"
          :show-land-name="false"
          @click.native="editFarmWorkRecord(item)"
        />
        <div class="create-farm-work-record-box">
          <van-button
            icon="plus"
            size="small"
            block
            class="create-farm-work-record"
            native-type="button"
            type="info"
            @click="createFarmWorkRecord"
          >
            添加农事记录
          </van-button>
        </div>
      </template>
    </wh-mobile-list>
    <farm-work-record-popup
      :visible.sync="popup.farmWork.visible"
      :init-form-data="popup.farmWork.initFormData"
      :form-type="popup.farmWork.formType"
      @submitFormSuccess="reloadList()"
    />
  </div>
</template>

<script>
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import FarmWorkRecordPopup from '@/views/productManage/components/FarmWorkRecordPopup'
import FarmWorkRecordItem from '@/views/productManage/PlotDetail/FarmWorkRecord/FarmWorkRecordItem'

export default {
  name: 'FarmWorkRecord',
  components: { FarmWorkRecordItem, FarmWorkRecordPopup, WhMobileList },
  props: {
    // 通过绑定 route.query 传递
    landId: {
      type: Number,
      default: undefined
    },
    landName: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      extraParams: {
        landId: this.landId
      },
      popup: {
        farmWork: {
          visible: false,
          initFormData: {},
          formType: 'create'
        }
      }
    }
  },
  methods: {
    createFarmWorkRecord() {
      this.popup.farmWork.visible = true
      this.popup.farmWork.formType = 'create'
      this.popup.farmWork.initFormData = {
        landId: this.landId,
        landName: this.landName
      }
    },
    editFarmWorkRecord(item) {
      this.popup.farmWork.visible = true
      this.popup.farmWork.formType = 'edit'
      this.popup.farmWork.initFormData = item
    },
    reloadList() {
      this.$refs.farmWorkRecordList.onRefresh()
    }
  }
}
</script>

<style lang='less' scoped>
.create-farm-work-record {
  margin-top: 10px;
}
.farm-work-record-list {
  /*margin-top: 10px;*/
  margin: 10px 20px 0 20px;
  .farm-work-record-item {
    border-radius: 6px;
    margin-bottom: 10px;
  }
}
.create-farm-work-record-box {
  /*margin: 20px 20px 0 20px;*/
}
</style>
